import { capitalizeString } from "@shared/helpers/capitalize-string.helper";
import { OrderKeiron, OrderKeironResponse } from "../interfaces/keiron.interface";

/**
 * Adapta una respuesta de tipo `OrderKeiron[]` a un arreglo de `OrderKeironResponse[]`.
 * 
 * @param response - Arreglo de objetos `OrderKeiron` recibidos de la fuente de datos.
 * @returns Un nuevo arreglo de objetos `OrderKeironResponse` con los campos adaptados.
 */
export const adaptResponseToSource = (response: OrderKeiron[]): OrderKeironResponse[] => {
    return response.map(item => ({
        dealId: item.dealId,
        status: capitalizeString(item.status),
        professionalRut: item.professionalRut,
        requestId: item.requestId,
        quotationId: item.quotationId,
        patientDisplay: item.patient?.display,
        patientId: item.patient?.id,
        patientDocumentNumber: item.patient?.documentNumber,
        benefit: item.benefit,
        quotationStatus: item.quotationStatus,
        patientAnswered: item.patientAnswered,
        shortId: item.shortId ? item.shortId.toUpperCase() : 'No Aplica',
        center: item.center || null,
        createdAt: item.createdAt?.toUpperCase().split('T')[0] || 'No Aplica',
        app: item.app
    }));
}